export function findNotEmptyField<T extends Record<string, any>>(
  fieldName: string,
  array: T[]
): T | undefined {
  return array.find((item: T) => (fieldName ? item[fieldName] : item));
}

export function calculateSum<T = Record<string, string | number>>(
  array: T[] = [],
  fieldName?: string
): number {
  if (!fieldName) {
    return array.reduce((acc: number, item: any) => {
      const value = typeof item === 'string' ? parseFloat(item) : item;
      return acc + (isNaN(value) ? 0 : value);
    }, 0);
  }

  return array.reduce((acc: number, item: T) => {
    const value = (item as Record<string, string | number>)[fieldName];
    const numberValue = typeof value === 'string' ? parseFloat(value) : value;
    return acc + (isNaN(numberValue) ? 0 : numberValue);
  }, 0);
}
